<template>
  <div>
    <menu-item
      v-if="capabilities.includes('efx-color')"
      to="change-text-effect-color"
    >
      <div class="flex items-center justify-between">
        <div>{{ $t('customization.changeColor') }}</div>
        <div class="flex mr-2 items-center">
          <swatch
            :label="getColorTranslation(element.effectColor)"
            :hex="getColorHex(element.effectColor)"
            class="w-8 h-8 mr-2 ml-0"
          />
          <div>
            {{ getColorTranslation(element.effectColor) }}
          </div>
        </div>
      </div>
    </menu-item>
    <base-row
      v-if="
        element.effectConfig.hasOwnProperty('effectAngle') &&
        capabilities.includes('efx-angle')
      "
      class="flex items-center justify-between text-black p-2"
      style="line-height: 2"
    >
      <label class="w-1/2">
        {{ $t('label.effect_settings') }}
      </label>
      <Slider
        v-model.number="effectAngle"
        :min="10"
        :step="10"
        :max="320"
        :lazy="true"
      />
    </base-row>
  </div>
</template>

<script>
import Slider from '../../components/input/Slider.vue';
import MenuItem from '../../components/MenuItem';
import Swatch from '../../components/Swatch';
import ColorValues from '../../mixins/color-values';
import ActiveElement from '@/mixins/activeElement';
import Capabilities from '@/mixins/capabilities';
import Redirect from '@/mixins/redirect';

export default {
  name: 'TextEffectConfig',
  components: {
    MenuItem,
    Swatch,
    Slider
  },
  mixins: [ColorValues, ActiveElement, Capabilities, Redirect],
  computed: {
    capabilities() {
      return this.getElementCapabilities(this.element);
    },
    effectAngle: {
      get() {
        return this.element.effectConfig.effectAngle;
      },
      set(newAngle) {
        this.updateElement({
          effectConfig: {
            ...this.element.effectConfig,
            effectAngle: newAngle
          }
        });
        this.closeModal();
      }
    }
  }
};
</script>
